import { useEffect, useState } from 'react';

import { PerspectiveScope, PhaseChecklistRow, getPhaseChecklists } from './sitePerspectiveApi';

/**
 * The checklist rows of the phase on screen.
 *
 * Shared by the tile, which shows how much is open, and the drill-down table, which shows what.
 * Both ask for the same phase, so they ask the same way — a count that came from somewhere else
 * than the table below it would eventually disagree with it.
 */

export interface PhaseChecklistState {
    rows: PhaseChecklistRow[];
    loading: boolean;
    error: string | null;
}

export const openCount = (rows: PhaseChecklistRow[]): number =>
    rows.filter((row) => !row.done).length;

export const usePhaseChecklists = (scope: PerspectiveScope | null): PhaseChecklistState => {
    const [state, setState] = useState<PhaseChecklistState>({ rows: [], loading: false, error: null });

    // The scope object is rebuilt on every render of the page; its contents are what matter.
    const key = JSON.stringify(scope ?? {});

    useEffect(() => {
        if (!scope) {
            setState({ rows: [], loading: false, error: null });
            return;
        }

        let cancelled = false;
        setState((current) => ({ ...current, loading: true, error: null }));

        getPhaseChecklists(scope)
            .then((rows) => {
                if (!cancelled) setState({ rows, loading: false, error: null });
            })
            .catch((error: any) => {
                console.error('Could not load the phase checklists', error);
                if (!cancelled) {
                    setState({ rows: [], loading: false, error: error?.message ?? 'Fehler' });
                }
            });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);

    return state;
};
